import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { ContactAuthType } from "types/ContactTypes";

export const useSendContactAsUserMessage = (
  options?: UseMutationOptions<any, Error, ContactAuthType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["sendMessage"],
    mutationFn: async (data) => {
      const formData = new FormData();
      formData.append("message", data.message);
      formData.append("topic", data.topic);
      if (data.file) {
        formData.append("file", data.file);
      }
      return axiosInstance
        .post("/contact/auth", formData)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa wysyłanie wiadomości...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "send-message",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Wiadomość została wysłana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "send-message",
      });

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas wysyłania wiadomości.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "send-message",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useSendContactAsUserMessage;
